import { render, staticRenderFns } from "./aOwnerDetailHis.vue?vue&type=template&id=a7d10798&scoped=true"
import script from "./aOwnerDetailHis.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailHis.vue?vue&type=script&lang=js"
import style0 from "./aOwnerDetailHis.vue?vue&type=style&index=0&id=a7d10798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d10798",
  null
  
)

export default component.exports